/**
 * Quiz-api worker origin: the production site talks to the production worker
 * (deployed from the repo's main branch); every other host (dev., new., .test)
 * talks to the dev worker (deployed from the develop branch).
 */
var MMG_QUIZ_API_ORIGIN =
    'meandmygolf.com' === location.hostname || 'www.meandmygolf.com' === location.hostname
        ? 'https://quiz-api.meandmygolf.com'
        : 'https://dev-quiz-api.meandmygolf.com';

/**
 * This function is called when a Typeform is Ready.
 *
 * Set MP distinct id for not logged in users only, to prevent MP accounts incorrect merging.
 */
window.mmgTypeformReady = function({ formId }) {
    if (typeof mixpanel !== 'undefined' && typeof mixpanel.get_distinct_id === 'function') {
        const distinctId = mixpanel.get_distinct_id();
        if (distinctId) {
            const widget = document.querySelector('[data-tf-widget="' + formId + '"]');

            // Check, that user is not logged in.
            if (widget && '0' === widget.dataset.loggedIn) {
                const iframe = widget.querySelector('iframe');
                if (iframe) {
                    const url = new URL(iframe.src);
                    const hashParams = new URLSearchParams(url.hash.replace(/^#/, ''));

                    hashParams.set('mp_distinct_id', distinctId);
                    url.hash = hashParams.toString();
                    iframe.src = url.toString();
                }
            }
        }
    }
};

/**
 * This function is called when a Typeform is Started.
 */
window.mmgTypeformStarted = function({ formId, responseId }) {
    if (typeof mmg_event !== 'undefined') {
        var event_data = { 'form_id' : formId, 'responseId' : responseId};
        mmg_event.do_event('mmg_typeform_started', event_data);
    }
};


/**
 * This function is called when a Typeform is submitted.
 */
window.mmgTypeformSubmit = function({ formId, responseId }) {
    // Ensure dataLayer exists to prevent errors
    window.dataLayer = window.dataLayer || [];

    // Push the event to GTM
    window.dataLayer.push({
        'event': 'game_plan_submission',
        'formId': formId,
        'responseId': responseId
    });

    if (typeof mmg_event !== 'undefined') {
        fetch(`${MMG_QUIZ_API_ORIGIN}/?formId=${formId}&responseId=${responseId}`)
            .then(res => (res.ok ? res.json() : null))
            .catch(() => null)
            .then(data => {
                // mmg_typeform_submitted should always be tracked, with or without the worker's form_id/form_title/answers.
                var event_data = { 'form_id': formId };
                if (data) {
                    event_data.form_id = data.form_id;
                    event_data.form_title = data.form_title;

                    // Flatten the worker's {field_id: {question, answer, ref}} shape into
                    // {question: answer}, matching "Form Data" built server-side in
                    // MMG_Mixpanel::on_typeform_webhook().
                    if (data.answers) {
                        var form_data = {};
                        Object.keys(data.answers).forEach(function(field_id) {
                            var answer = data.answers[field_id];
                            form_data[answer.question] = answer.answer;
                        });
                        event_data.answers = form_data;
                    }
                }
                mmg_event.do_event('mmg_typeform_submitted', event_data);
            });
    }
};
